import React from 'react';
import { styled, Text } from '@volkswagen-onehub/components-core';
import { InfoCuotaProps } from '.';

const myWaySinServiciosCopies = [
  'El coche es tuyo',
  'Cuota personalizable',
  '-',
  '-',
  '-',
  'Con seguro de protección de pagos',
  'Con seguro de retirada carnet de conducir',
  'Al finalizar el contrato, tú decides si quedarte el coche, renovarlo o devolverlo',
];
const myWayConServiciosCopies = [
  'El coche es tuyo',
  'Cuota personalizable',
  'Primer año de seguro a todo riesgo con franquicia',
  'Con mantenimiento Long Drive Standard en Servicios Oficiales',
  '-',
  'Al finalizar el contrato, tú decides si quedarte el coche, renovarlo o devolverlo',
];
const myRentingCopies = [
  'El coche es de Volkswagen Renting S.A.',
  'Cuota personalizable',
  'Seguro y servicio complementario de reparaciones',
  'Con mantenimiento y reparaciones en servicios oficiales',
  'Con gestión de multas y pago de impuestos',
  'Al finalizar el contrato, devuelves el coche',
];

interface HeightDivProps {
  fraseIndex: number;
  numberOfOffers: number;
}

const HeightDiv = styled.div<HeightDivProps>`
  height: ${(props) => (props.numberOfOffers === 1 ? null : '68px')};
  margin-top: ${(props) => (props.fraseIndex === 0 ? null : '8px')};
`;

const RenderFrase = (props: { compString: string; fraseIndex: number; numberOfOffers: number }) => {
  return (
    <HeightDiv fraseIndex={props.fraseIndex} numberOfOffers={props.numberOfOffers}>
      <Text>
        {props.compString === '-' && props.numberOfOffers < 2 ? null : props.compString === '-' ? (
          <div style={{ textAlign: 'center' }}>{props.compString}</div>
        ) : (
          props.compString
        )}
      </Text>
    </HeightDiv>
  );
};

export const Comparador = (props: InfoCuotaProps) => {
  const { numberOfOffers } = props;
  const { myRenting, myWay } = props.offer;

  return (
    <>
      {myRenting === 1 &&
        myRentingCopies.map((f, i) => (
          <RenderFrase compString={f} key={`${i}-myRenting`} fraseIndex={i} numberOfOffers={numberOfOffers} />
        ))}
      {myWay.activo === 1 &&
        myWay.servicio === 1 &&
        myWayConServiciosCopies.map((f, i) => (
          <RenderFrase compString={f} key={`${i}-mywayServicios`} fraseIndex={i} numberOfOffers={numberOfOffers} />
        ))}
      {myWay.activo === 1 &&
        myWay.servicio === 0 &&
        myWaySinServiciosCopies.map((f, i) => (
          <RenderFrase compString={f} key={`${i}-myWaySinServicios`} fraseIndex={i} numberOfOffers={numberOfOffers} />
        ))}
    </>
  );
};
